import { useGoalDetailPortfoliosQuery } from "web_myplann/Api/Goals/useGoalDetailPortfoliosQuery";
import type { GoalPortfolioResponseDTO } from "web_myplann/Infrastructure/Api/Api";

const MIN_ALLOCATION = 5;

type AllocationLimits = {
	currentForThis: number;
	usedOnOther: number;
	maxForThis: number;
};

export const useAllocationLimits = (
	portfolio: GoalPortfolioResponseDTO | null,
): AllocationLimits => {
	const { data } = useGoalDetailPortfoliosQuery();

	const currentForThis = portfolio?.usagePercent ?? 0;
	const items = data?.data ?? [];
	const globalUsed =
		items.find((p) => p.id === portfolio?.portfolioId)?.usagePercent ??
		currentForThis;
	const usedOnOther = Math.max(0, globalUsed - currentForThis);
	const maxForThis = Math.max(MIN_ALLOCATION, 100 - usedOnOther);

	return { currentForThis, usedOnOther, maxForThis };
};

export const ALLOCATION_MIN = MIN_ALLOCATION;
export const ALLOCATION_STEP = 5;
